module.exports = __webpack_public_path__ + "img/zwetschge.90183591.png";